/**
 * based on: https://usehooks.com/useAuth/
 */
import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import HybridContext from '../hooks/useHybrid';
import { acquireHybrid } from './providerUtils';

const useProviderHybrid = () => {
  const auth = useAuth();
  const history = useHistory();
  const [data, setData] = useState(null);

  const getHybrid = useCallback(
    async () => acquireHybrid(setData, history, auth),
    [history, auth],
  );

  useEffect(() => {
    if (!auth.loading) {
      (async () => acquireHybrid(setData, history, auth))();
    }
  }, [auth, history]);

  return {
    ...data,
    getHybrid,
  };
};

export function ProviderHybrid({ children }) {
  const providerData = useProviderHybrid();
  return (
    <HybridContext.Provider value={providerData}>
      {children}
    </HybridContext.Provider>
  );
}

ProviderHybrid.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
